import Papa from 'papaparse';
import moment from 'moment';
import Highcharts from 'highcharts';

const categories = [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025];

const data_unicorns = [87, 170, 214, 253, 356, 462, 569, 973, 1299, 1381, 1349, 1467];

const data_valuation = [235, 560, 741, 859, 1276, 1591, 1895, 3439, 4443, 4505, 4667, 5318];

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export function initGrowthChart() {
    Highcharts.chart('growth-unicorns-chart', {
        title: {
            text: 'The Growth of Unicorns¹',
        },

        chart: {
            height: 450,
            plotBackgroundColor: null,
            backgroundColor: 'transparent',
            style: {
                fontFamily: 'Filson Pro',
            },
        },

        subtitle: {
            text: null,
        },

        credits: {
            enabled: false,
        },

        yAxis: [
            {
                softMax: 2000,
                title: {
                    text: 'Total Unicorns',
                    style: {
                        fontSize: 15,
                        fontWeight: 500,
                    },
                },
                labels: {
                    style: {
                        fontSize: '12px',
                        color: '#4b4b4b',
                    },
                    format: '{value:.0f}',
                },
            },
            {
                softMax: 6000,
                title: {
                    text: 'Aggregate Post-Money Valuation ($Bn)²',
                    rotation: 270,
                    margin: 30,
                    style: {
                        fontSize: 15,
                        fontWeight: 500,
                    },
                },
                labels: {
                    style: {
                        fontSize: '12px',
                        color: '#4b4b4b',
                    },

                    formatter: function () {
                        return `${formatter.format(this.value)}`;
                    },
                },
                opposite: true,
            },
        ],
        xAxis: {
            categories: categories,
            labels: {
                style: {
                    fontSize: '12px',
                },
                overflow: 'justify',
            },
        },
        legend: {
            enabled: true,
            itemStyle: {
                fontSize: '12px',
            },
        },

        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false,
                },
                marker: {
                    enabled: false,
                },
            },
        },

        tooltip: {
            xDateFormat: '%B %e, %Y',
            valueDecimals: 2,
            shared: true,
            style: {},
            backgroundColor: '#fff',
            borderWidth: 0,
            formatter: function() {

                let tooltipText = `
                <b>${this.x}</b>
                <br/>

                <p>
                    <span style="color: ${this.points[0].series.color}">\u25CF</span>
                    ${this.points[0].series.name}: <b>${formatter.format(this.points[0].y)}</b>
                </p>
                <br/>
                <p>
                    <span style="color: ${this.points[1].series.color}">\u25CF</span>
                    ${this.points[1].series.name}: <b>${this.points[1].y}</b>
                </p>
                
                `;
                return tooltipText;

            }
        },

        series: [
            {
                name: 'Aggregate Post-Money Valuation ($Bn)²',
                type: 'area',
                yAxis: 1,
                data: data_valuation,
                color: '#3b4559',
                fillOpacity: 1,
                lineWidth: 0,
            },
            {
                name: 'Total Unicorns',
                type: 'column',
                yAxis: 0,
                data: data_unicorns,
                color: '#98a4ae',
                borderWidth: 0,
            },
        ],

        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 500,
                    },
                    chartOptions: {
                        chart: {
                            height: 330,
                        },
                        yAxis: [
                            {
                                title: {
                                    style: {
                                        fontSize: 12,
                                    },
                                },
                            },
                            {
                                title: {
                                    style: {
                                        fontSize: 12,
                                    },
                                },
                            },
                        ],
                    },
                },
            ],
        },
    });
}
